<template>

</template>

<script>
  export default {
    name: 'CB_details',
  };
</script>

<style scoped>

</style>